// A list of domains which are the sources for project assets
// Useful to define the system with different ways of image optimisation GET params to apply
// The domain is a key of an object (not the value), as several domains can be related to the same source

export default {
  'ctfassets.net': 'contentful',
  'diptyqueparis.com': 'magento',
};
